import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { CustomReportServiceBase } from './custom-report/custom-report-base.service';
import {
    BoxResultType,
    CustomReportServiceView,
    GetDataFilterValuesParameters,
    GetServiceSubCategoryColumnChartValuesResultType,
    GetServiceSubCategoryLineChartValuesResultType,
    GetServiceSubCategoryMetricsValuesResultType,
    GetServiceSubCategoryValuesResultType,
    ReportResultColumnDto,
    ServiceSubCategoryClient,
    SharedReportDto
} from './reporting-api-proxies';

@Injectable({
    providedIn: 'root'
})
export class ServiceSubCategoryService extends CustomReportServiceBase<
    ServiceSubCategoryClient,
    CustomReportServiceView
> {
    constructor(protected override client: ServiceSubCategoryClient) {
        super(client);
    }

    async getValues(parameters: GetDataFilterValuesParameters): Promise<GetServiceSubCategoryValuesResultType[]> {
        return await lastValueFrom(this.client.serviceSubCategoryGetServiceSubCategoryValues(parameters));
    }

    async getBoxesValues(parameters: GetDataFilterValuesParameters): Promise<BoxResultType[]> {
        return await lastValueFrom(this.client.serviceSubCategoryGetServiceSubCategoryBoxesValues(parameters));
    }

    async getColumnChartValues(
        parameters: GetDataFilterValuesParameters
    ): Promise<GetServiceSubCategoryColumnChartValuesResultType[]> {
        return await lastValueFrom(this.client.serviceSubCategoryGetServiceSubCategoryColumnChartValues(parameters));
    }

    async getMetricsValues(
        parameters: GetDataFilterValuesParameters
    ): Promise<GetServiceSubCategoryMetricsValuesResultType> {
        return await lastValueFrom(this.client.serviceSubCategoryGetServiceSubCategoryMetricsValues(parameters));
    }

    async getLineChartValues(
        parameters: GetDataFilterValuesParameters
    ): Promise<GetServiceSubCategoryLineChartValuesResultType[]> {
        return await lastValueFrom(this.client.serviceSubCategoryGetServiceSubCategoryLineChartValues(parameters));
    }

    override async saveCustomReport(body: CustomReportServiceView): Promise<CustomReportServiceView> {
        if (body.isPublic) return await lastValueFrom(this.client.serviceSubCategorySaveCatalogReport(body));
        else return await lastValueFrom(this.client.serviceSubCategorySaveCustomReport(body));
    }

    override async getCustomReport(id: number): Promise<CustomReportServiceView> {
        return await lastValueFrom(this.client.serviceSubCategoryGetCustomReport(id));
    }

    override async shareReport(body: CustomReportServiceView): Promise<SharedReportDto> {
        return await lastValueFrom(this.client.serviceSubCategoryCreateSharedReport(body));
    }

    override async getSharedReport(id: string): Promise<CustomReportServiceView> {
        return await lastValueFrom(this.client.serviceSubCategoryGetSharedReport(id));
    }

    override async getResultAvailableColumns(organizationIds: number[]): Promise<ReportResultColumnDto[]> {
        return await lastValueFrom(this.client.serviceSubCategoryResultAvailableColumns(organizationIds));
    }
}
